import { RootState } from "@/store/store";
import { activeProviderConnectionConfigSelector } from "@/store/provider-connections/selectors/active-connection/activeProviderConnectionConfigSelector";
import { ActiveProviderConnectionConfig } from "@/store/provider-connections/providerConnectionsSlice";

export const activeProviderConnectionCurrentStepSelector = (
  state: RootState,
): ActiveProviderConnectionConfig["step"] => {
  return activeProviderConnectionConfigSelector(state)?.step ?? 0;
};
